import Toast from "react-native-toast-message";

export const toastSuccess = (title: string) => {
  Toast.show({
    type: "success",
    props: { title },
  });
};

export const toastError = (title: string) => {
  Toast.show({
    type: "error",
    props: { title },
  });
};
